import PageContainer from 'components/common/PageContainer/PageContainer';
import { TreeProgramTopHeader } from 'components/common';
import { excellenceAppsConfig } from 'components/Dashboards/ExcellenceApps/excellenceAppsConfig';
import { ShareInsightButton } from 'components/common/ShareInsightButton/ShareInsightButton';
import { useFullStoryPageView } from 'hooks/useFullstoryPageView';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { ActivitiesGraph } from 'components/widgets/ActivitiesGraph/ActivitiesGraph';
import { PageWidgetWrapper } from 'components/common/PageWidgetWrapper/PageWidgetWrapper';

export const ActivitiesGraphPage = () => {
    useFullStoryPageView({ pageName: excellenceAppsConfig.activitiesGraph.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TreeProgramTopHeader pageTitle={excellenceAppsConfig.activitiesGraph.title}>
                            <ShareInsightButton
                                title={excellenceAppsConfig.activitiesGraph.title}
                                link={window.location.href}
                            />
                        </TreeProgramTopHeader>
                    </VersionSection>
                </VersionWrapper>
            </HeaderWrapper>
            <MainContent>
                <PageWidgetWrapper>
                    <ActivitiesGraph />
                </PageWidgetWrapper>
            </MainContent>
        </PageContainer>
    );
};
